import { applyAuth0Theme } from "@/utils/theme";

import MFAEnrollOptions from "./components/MFAEnrollOptions";
import { useMfaBeginEnrollOptionsManager } from "./hooks/useMFABeginEnrollOptionsManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MFABeginEnrollOptions() {
    // Extracting attributes from hook made out of MFABeginEnrollOptionsInstance class of Auth0 React SDK
    const { mfaBeginEnrollOptions, texts, locales } =
        useMfaBeginEnrollOptionsManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(mfaBeginEnrollOptions);
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>

            <MFAEnrollOptions />

        </AuthLayout>
    );
}

export default MFABeginEnrollOptions;
